import { Player } from "@lottiefiles/react-lottie-player";

interface EmptyStateProps {
  title: string;
  description?: string;
  animationPath: string;
  className?: string;
  size?: number | string;
}

export function EmptyState({ title, description, animationPath, className = "", size = 300 }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center p-4 ${className}`}>
      <Player autoplay loop src={animationPath} style={{ height: size, width: size }} />
      <h3 className="mt-4 text-lg text-center font-semibold text-foreground">{title}</h3>
      {description ? <p className="mt-2 text-sm text-foreground/60 text-center">{description}</p> : null}
    </div>
  );
}
